import { Injectable } from '@angular/core';
import {FileUploadService} from "./apps/file/file-upload.service";
import { HttpResponse } from '@angular/common/http';
import {ToastrService} from "ngx-toastr";

@Injectable({
  providedIn: 'root'
})
export class MediaViewerService {

  constructor(private fileService: FileUploadService, private toastService: ToastrService) { }

  /**
   * Dosyayı media-viewer'da açar
   * @param organizationId
   * @param fileUrl Dosya URL'i (opsiyonel)
   * @param fileName Dosya adı (opsiyonel)
   * @param windowFeatures Pencere özellikleri (opsiyonel)
   */
  openFile(organizationId: number, fileUrl?: string, fileName?: string, windowFeatures?: string): void {
    this.toastService.info("Dosyanız açılıyor...")
    // Eğer fileUrl varsa, viewFile servisini çağır
    if (fileUrl) {
      // fileUrl bir token ise direkt kullan, değilse önce token al
      if (fileUrl.startsWith('http') || fileUrl.startsWith('data:') || fileUrl.startsWith('blob:')) {
        // Direkt URL ise
        this.openMediaViewer(fileUrl, fileName, windowFeatures, organizationId, fileUrl);
      } else {
        // Token ise viewFile çağır
        this.fileService.viewFile(organizationId, fileUrl).subscribe({
          next: (response: any) => {
            let actualFileUrl: string = '';

            try {
              // Response HttpResponse ise (observe: 'response' kullandığımız için)
              if (response instanceof HttpResponse && response.body) {
                const blob = response.body;
                // PDF için doğru MIME type'ı belirle
                const fileExtension = this.getFileExtension(fileName || '').toLowerCase();
                let mimeType = blob.type;

                if (fileExtension === '.pdf' || fileExtension === '.odt' || fileExtension === '.doc' || fileExtension === '.docx') {
                  mimeType = 'application/pdf';
                } else if (fileExtension === '.jpg' || fileExtension === '.jpeg') {
                  mimeType = 'image/jpeg';
                } else if (fileExtension === '.png') {
                  mimeType = 'image/png';
                } else if (fileExtension === '.gif') {
                  mimeType = 'image/gif';
                }
                // Doğru MIME type ile yeni blob oluştur
                const correctedBlob = new Blob([blob], { type: mimeType });
                actualFileUrl = URL.createObjectURL(correctedBlob);
              } else if (response instanceof Blob) {
                actualFileUrl = URL.createObjectURL(response);
              } else {
                // String response ise
                if (typeof response === 'string') {
                  try {
                    // JSON parse etmeye çalış
                    const jsonResponse = JSON.parse(response);
                    actualFileUrl = jsonResponse.url || jsonResponse.fileUrl || jsonResponse.downloadUrl ||
                                   jsonResponse.data?.url || jsonResponse.data?.fileUrl || '';
                  } catch (parseError) {
                    actualFileUrl = response;
                  }
                } else {
                  // Object response ise
                  actualFileUrl = response.url || response.fileUrl || response.downloadUrl ||
                                 response.data?.url || response.data?.fileUrl || response;
                }
              }

              // URL kontrolü
              if (!actualFileUrl || actualFileUrl === '' || actualFileUrl === null || actualFileUrl === undefined) {
                console.error('actualFileUrl boş veya geçersiz:', actualFileUrl);
                console.error('Response detayı:', response);
                actualFileUrl = fileUrl;
              }

              const result = this.openMediaViewer(actualFileUrl, fileName, windowFeatures, organizationId, fileUrl);
            } catch (error) {
              console.error('Dosya işleme hatası:', error);
              this.openMediaViewer(fileUrl, fileName, windowFeatures, organizationId, fileUrl);
            }
          },
          error: err => {
            console.error('ViewFile hatası:', err);
            console.error('Hata detayları:', JSON.stringify(err, null, 2));
            this.openMediaViewer(fileUrl, fileName, windowFeatures, organizationId, fileUrl);
          }
        });
      }
    } else {
      this.openMediaViewer(fileUrl, fileName, windowFeatures, organizationId, fileUrl);
    }
  }

  /**
   * Media viewer penceresini açar
   * @param fileUrl Dosya URL'i
   * @param fileName Dosya adı
   * @param windowFeatures Pencere özellikleri
   * @param organizationId Organization ID (download için)
   * @param accessToken Access Token (download için)
   */
  private openMediaViewer(fileUrl?: string, fileName?: string, windowFeatures?: string, organizationId?: number, accessToken?: string): Window | null {

    const features = windowFeatures || '';

    let url = '/media-viewer';
    const params = new URLSearchParams();

    if (fileUrl) {
      params.append('fileUrl', fileUrl);
    }

    if (fileName) {
      params.append('fileName', fileName);
    }

    if (organizationId) {
      params.append('organizationId', organizationId.toString());
    }

    if (accessToken) {
      params.append('accessToken', accessToken);
    }

    if (params.toString()) {
      url += '?' + params.toString();
    }
    try {
      const windowResult = window.open(url, '_blank', features);
      if (!windowResult) {
        console.error('window.open returned null - popup might be blocked');
      }

      return windowResult;
    } catch (error) {
      console.error('Error opening window:', error);
      return null;
    }
  }

  // /**
  //  * Dosya seçici ile media-viewer'ı açar
  //  * @param windowFeatures Pencere özellikleri (opsiyonel)
  //  */
  // openFileSelector(windowFeatures?: string): Window | null {
  //   return this.openFile(undefined, undefined, windowFeatures);
  // }

  /**
   * Desteklenen dosya uzantılarını döndürür
   */
  getSupportedExtensions(): string[] {
    return ['.txt', '.md', '.doc', '.docx', '.odt', '.xlsx', '.xls', '.ods', '.csv', '.pdf', '.png', '.jpg', '.jpeg', '.mp4', '.avi'];
  }

  /**
   * Dosya uzantısının desteklenip desteklenmediğini kontrol eder
   * @param fileName Dosya adı
   */
  isFileSupported(fileName: string): boolean {
    const extension = this.getFileExtension(fileName);
    return this.getSupportedExtensions().includes(extension);
  }

  /**
   * Dosya uzantısını döndürür
   * @param fileName Dosya adı
   */
  private getFileExtension(fileName: string): string {
    return fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
  }
}
